const data = {
    "resultInfo": null,
    "linkId": 657938771,
    "merchantId": "eNahCA88522718176395",
    "merchantName": "MENTOR KNOWLEDGE MANAGEMENT PRIVATE LIMITED",
    "imageName": null,
    "imageData": null,
    "linkDescription": "SASTP - 01",
    "linkName": "69967",
    "amount": null,
    "amountMantissa": null,
    "amountExponent": null,
    "expiryDate": "21 Oct, 2024",
    "status": "PENDING",
    "longUrl": "https://securegw.paytm.in/link/paymentForm/69967/LL_657938771",
    "shortUrl": "https://paytm.me/eHm-Wlc",
    "smartPhone": false,
    "customerName": null,
    "customerPhoneNo": null,
    "customerEmail": null,
    "templateInfo": "SASTP - 01\n11 Study Abroad Services From Admission to Arrival\n\nAdmission Application, Scholarships, Education Loan, Visa Cover Letter, Interview Preparation, Accommodation\n\nStudy Abroad Like A Pro!",
    "paidAmount": null,
    "blockAmount": null,
    "isPartialPayment": false,
    "payableAmount": null,
    "fields": [
        {
            "name": "First Name",
            "type": "Text",
            "displayText": "",
            "helpText": "",
            "orientation": "H",
            "mandatory": true,
            "size": 100,
            "constraints": {
                "maxLength": "30",
                "minLength": "3",
                "isMandatoryValidation": true,
                "validationType": "textValidation"
            },
            "parentField": "Full Name",
            "placeholder": "First Name*",
            "isError": false,
            "errorName": "",
            "inputValue": "",
            "subText": ""
        },
        {
            "name": "Last Name",
            "type": "Text",
            "displayText": "",
            "helpText": "",
            "orientation": "H",
            "mandatory": true,
            "size": 100,
            "constraints": {
                "maxLength": "30",
                "minLength": "3",
                "isMandatoryValidation": true,
                "validationType": "textValidation"
            },
            "parentField": "Full Name",
            "placeholder": "Last Name*",
            "isError": false,
            "errorName": "",
            "inputValue": "",
            "subText": ""
        },
        {
            "name": "Mobile Number",
            "type": "Numeric",
            "displayText": "",
            "helpText": "",
            "orientation": "H",
            "mandatory": true,
            "size": 100,
            "constraints": {
                "maxLength": "10",
                "minLength": "10",
                "isMandatoryValidation": true,
                "validationType": "numberValidation"
            },
            "placeholder": "Mobile Number*",
            "isError": false,
            "errorName": "",
            "inputValue": "",
            "subText": ""
        },
        {
            "name": "Email ID",
            "type": "Text",
            "displayText": "",
            "helpText": "",
            "orientation": "H",
            "mandatory": true,
            "size": 100,
            "constraints": {
                "maxLength": "200",
                "minLength": "3",
                "isMandatoryValidation": true,
                "validationType": "textValidation"
            },
            "placeholder": "Email ID*",
            "isError": false,
            "errorName": "",
            "inputValue": "",
            "subText": ""
        },
        {
            "name": "Region/Area",
            "type": "Text",
            "displayText": "",
            "helpText": "City and Area",
            "orientation": "H",
            "mandatory": true,
            "size": 100,
            "constraints": {
                "maxLength": 200,
                "minLength": 3,
                "isMandatoryValidation": true,
                "validationType": "textValidation"
            },
            "subText": "City and Area",
            "placeholder": "Region/Area*",
            "isError": false,
            "errorName": "",
            "inputValue": ""
        },
        {
            "name": "Application Start Date",
            "type": "Date",
            "displayText": "",
            "helpText": "If you wish to start applying at a later date",
            "orientation": "H",
            "mandatory": true,
            "size": 100,
            "constraints": {
                "minValue": "23/10/2023",
                "maxValue": "24/10/2024",
                "isMandatoryValidation": true,
                "validationType": "dateValidation"
            },
            "subText": "If you wish to start applying at a later date",
            "placeholder": "Application Start Date*",
            "isError": false,
            "errorName": "",
            "inputValue": ""
        },
        {
            "name": "SASTP - 01",
            "type": "Amount",
            "displayText": "",
            "helpText": "Inclusive of GST",
            "orientation": "H",
            "mandatory": true,
            "size": 100,
            "constraints": {
                "value": "1",
                "minValue": "0",
                "maxValue": "10000000",
                "isMandatoryValidation": true,
                "validationType": "numberValidation"
            },
            "subText": "Inclusive of GST",
            "placeholder": "SASTP - 01*",
            "isError": false,
            "errorName": "",
            "inputValue": "1"
        }
    ],
    "partialLinkPayments": null,
    "triggerJSCheckout": false,
    "maxTxnAmount": null,
    "partialPayment": false,
    "partialAmountData": {
        "isPartialPayment": false,
        "paidAmount": "",
        "blockAmount": "",
        "payableAmount": "",
        "totalAmount": "",
        "partialLinkPayments": null
    }
};

module.exports = data;


// WEBPACK FOOTER //
// ../mock-app-data/form/date-widget/index.js